import { Divider } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { ProfileData } from "libs/codegen/property-onboarding";
import { Fragment } from "react";
import { useWatch } from "react-hook-form";
import { AccommodationCategoryEnum } from "../constants/accommodationCategoryEnum.ts";
import { useMetadataAtomValue } from "../metadataAtom.ts";
import { useAccommodationCategory } from "../useAccommodationCategory.ts";
import { CompanyDetailsController } from "./CompanyDetailsController";
import { ContactDetailsController } from "./ContactDetailsController";
import { GovernmentControlController } from "./GovernmentControlController";
import { HostDetailsController } from "./HostDetailsController";
import { HostTypeController } from "./HostTypeController";
import { UltimateOwnerController } from "./UltimateOwnerController";
import { hostTypeMapper } from "./constant";

export const ProfileFormFields = () => {
    const hostType = useWatch<ProfileData>({ name: "hostType" });

    const {
        experimentsAtom: { isConvergenceProfile },
    } = useMetadataAtomValue();
    const { hasAccommodationTypes } = useAccommodationCategory();
    const isHotelType = hasAccommodationTypes(AccommodationCategoryEnum.Hotel, AccommodationCategoryEnum.MultipleNha);

    return (
        <VStack gap="24" pb="32">
            {!(isConvergenceProfile && isHotelType) && <HostTypeController />}
            {hostType === hostTypeMapper.Professional && (
                <Fragment>
                    <Divider />
                    <CompanyDetailsController />
                    <Divider />
                    <UltimateOwnerController />
                    <Divider />
                    <GovernmentControlController />
                </Fragment>
            )}
            <Divider />
            <HostDetailsController />
            <Divider />
            <ContactDetailsController />
        </VStack>
    );
};
